// Colores del menú público. Los guarda el panel (ColorPicker) en el doc del negocio
// y los usa Business.jsx. El texto de los botones siempre es blanco, por eso las
// paletas usan botones oscuros.
export const PALETTES = [
    { name: "Clara", bodyColor: "#fbfaf7", selectColor: "#ffffff", fontColor: "#1e1520", arrowColor: "#2c0032", buttonColor: "#2c0032" },
    { name: "MiQRapp", bodyColor: "#2c0032", selectColor: "#5a0465", fontColor: "#ecedf2", arrowColor: "#86c252", buttonColor: "#4f8a1f" },
    { name: "Pizzería", bodyColor: "#fff8f1", selectColor: "#ffffff", fontColor: "#3a1a12", arrowColor: "#b3261e", buttonColor: "#b3261e" },
    { name: "Café", bodyColor: "#f5efe6", selectColor: "#fffaf3", fontColor: "#3b2a1e", arrowColor: "#7a4b2a", buttonColor: "#7a4b2a" },
    { name: "Verde", bodyColor: "#f2f7ee", selectColor: "#ffffff", fontColor: "#1f3317", arrowColor: "#2f6b1f", buttonColor: "#2f6b1f" },
    { name: "Mar", bodyColor: "#eef5fb", selectColor: "#ffffff", fontColor: "#12304a", arrowColor: "#1f5f99", buttonColor: "#1f5f99" },
    { name: "Noche", bodyColor: "#141217", selectColor: "#221e27", fontColor: "#f2f0f4", arrowColor: "#e0a43a", buttonColor: "#a3461c" }
];

export const COLOR_FIELDS = [
    ["bodyColor", "Fondo"],
    ["selectColor", "Tarjetas"],
    ["fontColor", "Texto"],
    ["arrowColor", "Detalles"],
    ["buttonColor", "Botones"]
];

const KEYS = COLOR_FIELDS.map(([key]) => key);

// Sin colores guardados, el menú usa la paleta Clara, que es la de la landing.
export const themeOf = (business) => Object.fromEntries(KEYS.map((key) => [key, business?.[key] || PALETTES[0][key]]));

export const sameTheme = (a, b) => KEYS.every((key) => a[key].toLowerCase() === b[key].toLowerCase());

// Variables CSS que usa menu.css.
export const themeStyle = (theme) => ({
    "--mn-bg": theme.bodyColor,
    "--mn-surface": theme.selectColor,
    "--mn-text": theme.fontColor,
    "--mn-accent": theme.arrowColor,
    "--mn-btn": theme.buttonColor
});
